export default __webpack_public_path__ + "static/media/gw220.bd10e80a.png";